package com.trevorwiebe.timesheet.admin.presentation

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.trevorwiebe.timesheet.core.presentation.TopBar
import com.trevorwiebe.timesheet.core.presentation.common.BackIcon
import com.trevorwiebe.timesheet.core.presentation.common.ResponsiveContent
import com.trevorwiebe.timesheet.core.presentation.common.isSideNavVisible
import com.trevorwiebe.timesheet.core.presentation.common.SectionLabel
import com.trevorwiebe.timesheet.core.presentation.common.botPadding

@Composable
fun AdminScreen(
    onNavigateToOrganization: () -> Unit,
    onNavigateToUserManagement: () -> Unit,
    onNavigateToRates: () -> Unit,
    onNavigateToLoadRates: () -> Unit,
    onNavigateToEquipment: () -> Unit,
    onNavigateToLocations: () -> Unit,
    onNavigateToCustomers: () -> Unit,
    onNavigateToCarriers: () -> Unit,
    onNavigateToOwnerOperators: () -> Unit,
    onNavigateToReporting: () -> Unit,
    onNavigateToEmployeeHours: () -> Unit,
    onBack: () -> Unit
) {
    val scrollState = rememberScrollState()

    Scaffold(
        topBar = {
            TopBar(
                title = "Admin",
                backIcon = if (isSideNavVisible()) null else ({ BackIcon() }),
                onBack = onBack
            )
        }
    ) { paddingValues ->
        ResponsiveContent(modifier = Modifier.padding(paddingValues)) {
        Column(
            modifier = Modifier
                .verticalScroll(scrollState)
                .fillMaxSize()
        ) {
            SectionLabel("Reports")
            AdminNavRow(
                title = "Mileage Reporting",
                subtitle = "IFTA reports & General",
                onClick = onNavigateToReporting
            )
            AdminNavRow(
                title = "Employee Hour Reports",
                subtitle = "Hours & submission status by employee",
                onClick = onNavigateToEmployeeHours
            )
            SectionLabel("Manage")
            AdminNavRow(
                title = "Equipment",
                subtitle = "Manage trucks and trailers",
                onClick = onNavigateToEquipment
            )
            AdminNavRow(
                title = "Locations",
                subtitle = "Manage fuel & delivery locations",
                onClick = onNavigateToLocations
            )
            AdminNavRow(
                title = "Customers",
                subtitle = "Manage customers",
                onClick = onNavigateToCustomers
            )
            AdminNavRow(
                title = "Carriers",
                subtitle = "Manage carriers",
                onClick = onNavigateToCarriers
            )
            AdminNavRow(
                title = "Load Rates",
                subtitle = "Manage load pricing templates",
                onClick = onNavigateToLoadRates
            )
            SectionLabel("Organization")
            AdminNavRow(
                title = "Organization",
                subtitle = "Edit organization details",
                onClick = onNavigateToOrganization
            )
            AdminNavRow(
                title = "User Management",
                subtitle = "Manage employee accounts",
                onClick = onNavigateToUserManagement
            )
            AdminNavRow(
                title = "Owner Operators",
                subtitle = "Manage owner operators",
                onClick = onNavigateToOwnerOperators
            )
            AdminNavRow(
                title = "Rates",
                subtitle = "Manage pay rates",
                onClick = onNavigateToRates
            )
            Spacer(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(botPadding())
            )
        }
        }
    }
}

@Composable
private fun AdminNavRow(
    title: String,
    subtitle: String? = null,
    onClick: () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(
                    start = 16.dp,
                    end = 16.dp,
                    top = 16.dp,
                    bottom = if (subtitle == null) 16.dp else 0.dp
                )
        ) {
            Text(
                text = title,
                fontSize = 16.sp,
                fontWeight = FontWeight.SemiBold
            )
        }
        if (subtitle != null) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(start = 16.dp, end = 16.dp, bottom = 16.dp)
            ) {
                Text(
                    text = subtitle,
                    fontSize = 14.sp,
                    color = MaterialTheme.colorScheme.secondary
                )
            }
        }
        HorizontalDivider()
    }
}
